export const SET_IS_ADMIN = "SET_IS_ADMIN";
export const SET_IS_WT_ADMIN = "SET_IS_WT_ADMIN";
export const SET_IS_WT_ADMIN_SUPER = "SET_IS_WT_ADMIN_SUPER";
export const SET_IS_NON_ADMIN = "SET_IS_NON_ADMIN";
export const SET_EMAIL_NOT_CONFIRMED = "SET_EMAIL_NOT_CONFIRMED";
export const SET_PASSWORD_CHANGED = "SET_PASSWORD_CHANGED";
export const SET_IS_TEAM_LEADER = "SET_IS_TEAM_LEADER";
